import React from 'react';
import { hydrate, render } from 'react-dom';
import App from './App';
import './index.css'; // Corrected import path

// Ensure React is globally available
if (typeof window !== 'undefined') {
  window.React = React;
}

// Support for react-snap prerendering
const rootElement = document.getElementById('root');

// If we're prerendering with react-snap, use hydrate, otherwise use render
if (rootElement.hasChildNodes()) {
  hydrate(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
} else {
  render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
}

// Register service worker for production environments
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
